// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"22ec263a","513":"d0313d8b","787":"bd3eb24c"}[chunkId] + ".chunk.js";
};